React = require 'react'
{ Component, PropTypes } = React

class Admin extends Component
	render: =>
		React.createElement("div", {"className": "fill-display"},
			(@props.children)
		)

module.exports = Admin



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/olos/js/containers/Admin.cjsx